import { useNetwork } from "@eusoft/webapp-framework";
import { popupEditAsync } from "@eusoft/webapp-framework/helpers/Editor";
import { objectEditor, required, range, enumItemsSource } from "@eusoft/webapp-ui";
import { RefundOrderReason, type IOrderListView } from "../entities/Commands";
import { context } from "../services/Context";
import { executeAsync } from "../services/DataService";
import { withSignManager } from "../services/SignManager";


export async function refundOrderAsync(order: IOrderListView) {


    let data = {
        amount: order.total,
        reason: undefined as RefundOrderReason,
        note: undefined as string,
    }

    const editor = objectEditor(bld => <>
        {bld.number(a => a.amount, {
            validators: [required, range(0.01, order.total)],
            editor: {
            }
        })}
        {bld.singleSelector(a => a.reason, {
            validators: [required],
            editor: {
                itemsSource: enumItemsSource(RefundOrderReason)
            }
        })}
        {bld.text(a => a.note, {
            editor: {
                multiLine: true,
                rows: 3
            }
        })}
    </>, {
        value: data,
        style: "vertical",
        commitMode: "manual-inplace",
        inputField: {
            style: "filled"
        },
    });

    data = await popupEditAsync(editor, data, {
        title: "refund-order"
    });

    if (!data)
        return;

    const res = await useNetwork(() =>
        withSignManager(cid =>
            executeAsync("RefundOrder", {
                amount: data.amount,
                note: data.note,
                salePointId: context.salePoint?.id,
                orderId: order.id,
                operatorId: context.operator?.id,
                reason: data.reason,
                connectionId: cid
            })));

    return res;
}

